import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { 
  Tag, Percent, Gift, Snowflake, Sun, 
  Clock, ChevronRight, Star, Zap, Users,
  Car, Sparkles, Calendar
} from 'lucide-react';

const PROMOTIONS = [
  // Offres du moment
  {
    id: 'promo-1',
    type: 'moment',
    title: '-10% sur le Lavage VIP',
    description: 'Profitez de notre lavage VIP complet à prix réduit. Intérieur, extérieur, finitions parfaites.',
    discount: '-10%',
    original_price: 55,
    promo_price: 49.50,
    valid_until: '31 Décembre 2026',
    icon: Star,
    color: 'text-yellow-400',
    bgColor: 'bg-yellow-500/10',
    borderColor: 'border-yellow-500/30',
    featured: true,
    conditions: 'Offre valable sur présentation de cette promotion'
  },
  {
    id: 'promo-2',
    type: 'moment',
    title: 'Contrôle Technique à 85€',
    description: 'Votre contrôle technique au meilleur prix. Sans rendez-vous possible.',
    discount: '-10€',
    original_price: 95,
    promo_price: 85,
    valid_until: '31 Décembre 2026',
    icon: Car,
    color: 'text-green-400',
    bgColor: 'bg-green-500/10',
    borderColor: 'border-green-500/30',
    featured: false,
    conditions: 'Sur présentation de cette promotion'
  },
  
  // Offres de bienvenue
  {
    id: 'promo-3',
    type: 'bienvenue',
    title: '-10% Première Visite',
    description: 'Bienvenue chez Le Hub ! Bénéficiez de 10% de réduction sur votre première prestation.',
    discount: '-10%',
    icon: Gift,
    color: 'text-pink-400',
    bgColor: 'bg-pink-500/10',
    borderColor: 'border-pink-500/30',
    featured: true,
    conditions: 'Réservé aux nouveaux clients. Non cumulable avec d\'autres offres.'
  },
  {
    id: 'promo-4',
    type: 'bienvenue',
    title: 'Lavage CLEAN Offert',
    description: 'Pour toute première réparation de plus de 200€, votre lavage CLEAN est offert !',
    discount: 'OFFERT',
    icon: Sparkles,
    color: 'text-blue-400',
    bgColor: 'bg-blue-500/10',
    borderColor: 'border-blue-500/30',
    featured: false,
    conditions: 'Pour toute facture supérieure à 200€. Nouveaux clients uniquement.'
  },

  // Offres saisonnières
  {
    id: 'promo-5',
    type: 'saison',
    title: 'Pack Hiver Complet',
    description: 'Préparez votre véhicule pour l\'hiver : vérification batterie, antigel, pneus hiver, éclairage.',
    discount: '-10%',
    original_price: 120,
    promo_price: 108,
    valid_until: '28 Février 2026',
    icon: Snowflake,
    color: 'text-cyan-400',
    bgColor: 'bg-cyan-500/10',
    borderColor: 'border-cyan-500/30',
    featured: true,
    conditions: 'Pack incluant main d\'œuvre. Pièces en supplément si remplacement nécessaire.'
  },
  {
    id: 'promo-6',
    type: 'saison',
    title: 'Révision de Printemps',
    description: 'Vidange + filtres + contrôle des niveaux + points de sécurité. Votre véhicule prêt pour les beaux jours.',
    discount: '-10%',
    original_price: 149,
    promo_price: 134,
    valid_until: '30 Avril 2026',
    icon: Sun,
    color: 'text-orange-400',
    bgColor: 'bg-orange-500/10',
    borderColor: 'border-orange-500/30',
    featured: false,
    conditions: 'Huile standard incluse. Supplément possible selon véhicule.'
  },

  // Offres parrainage
  {
    id: 'promo-7',
    type: 'parrainage',
    title: 'Parrainage : 20€ pour vous et votre filleul',
    description: 'Recommandez Le Hub à vos proches. Vous recevez chacun un bon de 20€ utilisable sur tous nos services.',
    discount: '2x20€',
    icon: Users,
    color: 'text-purple-400',
    bgColor: 'bg-purple-500/10',
    borderColor: 'border-purple-500/30',
    featured: false,
    conditions: 'Le filleul doit effectuer une prestation d\'au moins 50€.'
  },
];

const PROMO_TYPES = [
  { id: 'all', name: 'Toutes', icon: Tag },
  { id: 'moment', name: 'Du moment', icon: Zap },
  { id: 'bienvenue', name: 'Bienvenue', icon: Gift },
  { id: 'saison', name: 'Saisonnières', icon: Calendar },
  { id: 'parrainage', name: 'Parrainage', icon: Users },
];

import { useState } from 'react';

export default function PromotionsPage() {
  const [activeFilter, setActiveFilter] = useState('all');
  
  const filteredPromos = activeFilter === 'all' 
    ? PROMOTIONS 
    : PROMOTIONS.filter(p => p.type === activeFilter);
  
  const featuredPromos = PROMOTIONS.filter(p => p.featured);

  return (
    <div className="min-h-screen bg-[#09090B]">
      {/* Hero */}
      <section className="bg-gradient-to-b from-zinc-900 to-[#09090B] py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center gap-2 bg-red-600/20 text-red-400 px-4 py-2 rounded-full border border-red-600/30 mb-6">
            <Percent size={18} />
            <span className="text-sm font-medium">Offres exclusives</span>
          </div>
          <h1 className="text-5xl font-bold text-white mb-4">
            NOS <span className="text-red-500">PROMOTIONS</span>
          </h1>
          <p className="text-xl text-zinc-400 max-w-2xl mx-auto">
            Profitez de nos offres spéciales et économisez sur l'entretien de votre véhicule
          </p>
        </div>
      </section>

      {/* Featured Promos Banner */}
      <section className="py-8 bg-gradient-to-r from-red-900/20 via-red-600/10 to-red-900/20 border-y border-red-500/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-center gap-8 flex-wrap">
            <span className="text-red-400 font-bold uppercase tracking-wider flex items-center gap-2">
              <Zap size={20} /> Offres à ne pas manquer
            </span>
            {featuredPromos.slice(0, 3).map((promo) => (
              <span key={promo.id} className="text-white font-medium">
                {promo.title}
              </span>
            ))}
          </div>
        </div>
      </section>

      {/* Filters */}
      <section className="border-b border-zinc-800 sticky top-20 z-30 bg-[#09090B]/95 backdrop-blur">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex gap-2 py-4 overflow-x-auto">
            {PROMO_TYPES.map((type) => (
              <Button
                key={type.id}
                variant={activeFilter === type.id ? 'default' : 'ghost'}
                size="sm"
                onClick={() => setActiveFilter(type.id)}
                className={activeFilter === type.id 
                  ? 'bg-red-600 text-white' 
                  : 'text-zinc-400 hover:text-white'
                }
                data-testid={`filter-promo-${type.id}`}
              >
                <type.icon size={16} className="mr-2" />
                {type.name}
              </Button>
            ))}
          </div>
        </div>
      </section>

      {/* Promotions Grid */}
      <section className="py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredPromos.map((promo, idx) => (
              <Card 
                key={promo.id}
                className={`bg-zinc-900/50 border-zinc-800 overflow-hidden card-hover animate-fade-in ${
                  promo.featured ? `ring-1 ${promo.borderColor}` : ''
                }`}
                style={{ animationDelay: `${idx * 0.05}s` }}
                data-testid={`promo-card-${promo.id}`}
              >
                {promo.featured && (
                  <div className="bg-red-600 text-white text-xs font-bold py-1 px-3 text-center">
                    OFFRE VEDETTE
                  </div>
                )}
                
                <div className={`h-2 ${promo.bgColor}`} />
                
                <CardContent className="p-6">
                  <div className="flex items-start gap-4 mb-4">
                    <div className={`w-14 h-14 ${promo.bgColor} rounded-xl flex items-center justify-center flex-shrink-0`}>
                      <promo.icon className={promo.color} size={28} />
                    </div>
                    <div className="flex-1">
                      <Badge className={`${promo.bgColor} ${promo.color} border-0 mb-2`}>
                        {promo.discount}
                      </Badge>
                      <h3 className="text-xl font-bold text-white">{promo.title}</h3>
                    </div>
                  </div>
                  
                  <p className="text-zinc-400 text-sm mb-4">{promo.description}</p>
                  
                  {promo.original_price && (
                    <div className="flex items-center gap-3 mb-4">
                      <span className="text-zinc-500 line-through">{promo.original_price}€</span>
                      <span className="text-3xl font-bold text-red-500">{promo.promo_price.toFixed(2).replace('.', ',')}€</span>
                    </div>
                  )}
                  
                  {promo.valid_until && (
                    <div className="flex items-center gap-2 text-zinc-500 text-sm mb-4">
                      <Clock size={14} />
                      <span>Valable jusqu'au {promo.valid_until}</span>
                    </div>
                  )}
                  
                  <div className="pt-4 border-t border-zinc-800">
                    <p className="text-zinc-500 text-xs mb-4">{promo.conditions}</p>
                    <Link to="/reservation">
                      <Button className="w-full bg-red-600 hover:bg-red-700">
                        En profiter
                        <ChevronRight size={16} className="ml-1" />
                      </Button>
                    </Link>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter CTA */}
      <section className="py-16 bg-zinc-900/50 border-t border-zinc-800">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <Gift className="mx-auto text-red-500 mb-4" size={48} />
          <h2 className="text-3xl font-bold text-white mb-4">NE RATEZ AUCUNE OFFRE</h2>
          <p className="text-zinc-400 mb-8">
            Inscrivez-vous à notre newsletter pour recevoir nos promotions en avant-première
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center max-w-md mx-auto">
            <input 
              type="email" 
              placeholder="Votre email" 
              className="flex-1 px-4 py-3 bg-zinc-800 border border-zinc-700 rounded-lg text-white placeholder:text-zinc-500 focus:outline-none focus:border-red-500"
              data-testid="newsletter-email"
            />
            <Button className="bg-red-600 hover:bg-red-700 px-6">
              S'inscrire
            </Button>
          </div>
          <p className="text-zinc-600 text-xs mt-4">
            En vous inscrivant, vous acceptez de recevoir nos offres commerciales. Désabonnement possible à tout moment.
          </p>
        </div>
      </section>

      {/* Info */}
      <section className="py-12 border-t border-zinc-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-6 text-center">
            <div>
              <Percent className="mx-auto text-red-500 mb-3" size={32} />
              <h3 className="text-white font-bold mb-2">Offres Cumulables</h3>
              <p className="text-zinc-400 text-sm">Certaines offres peuvent être combinées avec votre programme fidélité</p>
            </div>
            <div>
              <Clock className="mx-auto text-red-500 mb-3" size={32} />
              <h3 className="text-white font-bold mb-2">Durée Limitée</h3>
              <p className="text-zinc-400 text-sm">Nos promotions sont valables dans la limite des stocks et dates indiquées</p>
            </div>
            <div>
              <Star className="mx-auto text-red-500 mb-3" size={32} />
              <h3 className="text-white font-bold mb-2">Qualité Garantie</h3>
              <p className="text-zinc-400 text-sm">Prix réduits mais qualité de service toujours au rendez-vous</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
